import { FC } from 'react'
import { dynamicRoutes } from '../../../../../constants/routes'
import { Link } from 'react-router-dom'
import { Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'

interface EditProps {
    stampDocId: string
}

const Edit: FC<EditProps> = ({ stampDocId }) => {
    return (
        <Link to={dynamicRoutes.equipmentStamp(stampDocId)}>
            <Button size={'small'} icon={<EditOutlined />} title={'Редактировать штамп'} />
        </Link>
    )
}

export default Edit
